export default {
  version: "2021.01.21 @ " + process.env.VUE_APP_TITLE,
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  baseUrl: process.env.VUE_APP_BASE_URL,
  r1Url: process.env.VUE_APP_R1_URL,
  r2Url: process.env.VUE_APP_R2_URL,
  userBaseUrl: "/sbop",
  accessRoles: {
    account: "account",
    report: "report",
    subAccount: "sub_account",
    editAccount: "edit_account",
    editLimit: "edit_limit",
    editIp: "edit_ip",
    editOperatorLimit: "operator_limit",
    stock: "stock",
    log: "log",
    messages: "messages",
    tournament: "tournament"
  },
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://api." + domain;
    } else {
      return this.baseUrl;
    }
  },
  oddsType: {
    1: "MY",
    2: "HK",
    3: "ID",
    4: "DEC"
  },
  loginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/loginapi";
  },
  secAccountFullUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addsecondaryapi";
  },
  securityValidateUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/securityvalidateapi";
  },
  securityUpdateUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/securityupdateapi";
  },
  updatePasswordUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/passwordupdateapi";
  },
  securityDisableUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/securitydisableapi";
  },
  getGameTypeLookupUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/matchresultgametypelookup";
  },
  getLeagueLookupUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/matchresultleaguelookup";
  },
  getMatchResultUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/matchresult";
  },
  getSubAccountListUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountsublistapi";
  },
  addSubAccountUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/addsubapi";
  },
  resetPasswordSubUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetsubapi";
  },
  getSubAccountDetailsUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubdetailapi";
  },
  updateAuthorityUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/setauthorityapi";
  },
  resetPasswordPostUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetpostapi";
  },
  subAccountBlockUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubblockapi";
  },
  subAccountUnblockUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubunblockapi";
  },
  getSettlementHistoryUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/transfercashhistoryapi";
  },
  getCancelledBetlistUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/cancelledbetlistapi";
  },
  getHdpPackageUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/hdppackagegetapi";
  },
  getOperatorDefaultBetLimitUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/operatordefaultget";
  },
  updateOperatorBetLimitUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/operatordefaultupsert";
  },
  getBetLimitUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitgetapi";
  },
  getPositionTakingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/positiongetapi";
  },
  getCommissionUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/hdppackagegetapi";
  },
  checkDownlineExistUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountcheckexistsapi";
  },
  addAccountUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/addaccountapi"
  },
  getAccountListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountagentlistapi";
  },
  getMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountmemberlistapi";
  },
  updateStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/statusupdateapi";
  },
  unblockProfileUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountprofileunblockapi";
  },
  resetPasswordUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetapi";
  },
  getDailyStatementUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/dailystatementapi";
  },
  getGameResultSportsbookUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultsportsbookapi";
  },
  getMatchResultParlayDetailUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/matchresultparlaydetail";
  },
  getParlayDetailUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/parlaydetail";
  },
  getDailyWinloseUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinloseapi";
  },
  getKeyListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/keylist";
  },
  insertKeyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/keyinsert";
  },
  updateKeyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/keyupdate";
  },
  getIpListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iplist";
  },
  updateIpUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipupdate";
  },
  updatePositionTakingSB1Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatepositionsportsbookapi";
  },
  updateCommissionSBUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatehdppackageapi";
  },
  updateBetLimitSBUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatebetlimitsportsbookapi";
  },
  transferCashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/transfercashapi";
  },
  checkAccountReservedUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountcheckreservedapi";
  },
  getPendingMatchesUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/pendingmatchesapi";
  },
  getDashboardInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/walletgetapi";
  },
  getStockHDPUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/stockhdpapi";
  },
  getStockOEUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/stockoeapi";
  },
  getStockOutstandingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/stockoutstandingapi";
  },
  getActiveBetlistHDPUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/activebetlisthdpapi";
  },
  getActiveBetlistOEUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/activebetlistoeapi";
  },
  getActiveBetlistBetTypeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/activebetlistbettypeapi";
  },
  getActiveBetlistAllUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/activebetlistallapi";
  },
  // getActiveBetlistDetailUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/active_bet_list_detail";
  // },
  getSportTypeWinloseDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl +"/sporttypewinloseapi";
  },
  getLeagueWinloseDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaguewinloseapi";
  },
  getMatchWinloseDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchwinloseapi";
  },
  getMatchMemberWinloseDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchmemberwinloseapi";
  },
  getMatchResultMMOParlayDetailUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/matchresultmmoparlaydetail";
  },
  getMMOParlayDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mmoparlaydetail";
  },
  updatePositionTakingMMOUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatepositionsportsbookmmoapi";
  },
  checkDownlineUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/accountcheckapi";
  },
  betLimitLogUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitlog";
  },
  announceListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/announcememberlist";
  },
  marqueeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/announcemembermarquee";
  },
  personalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/announcepersonal";
  },
  personalUnreadUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/announcepersonalunread";
  },
  getSystemParlayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/systemparlayapi";
  },
  getBetSystemParlayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betsysparlay";
  },
  getBetSystemParlayMatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betsysparlaymatch";
  },
  getBetSystemParlayBetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betsysparlaybet";
  },
  getBetParlayAcceptListDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betparlayacceptlistdetail";
  },
  getBetParlayRejectListDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betparlayrejectlistdetail";
  },
  //desmond, 20230216
  getTournamentLeagueLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaguelookup";
  },
  getTournamentMatchLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchlookup";
  },
  getTournamentRoomListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/oproomlistall";
  },
  createTournamentPublicRoomUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/roomcreatepublic";
  },
  getTournamentRoomMatchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/roommatchlist";
  },
  getGameResultTournamentDetailUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/gameresulttournamentdetailapi";
  },
  getGameResultTournamentRefundUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/gameresulttournamentrefundapi";
  },
  getPlatformWinloseDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/platformwinloseapi";
  },
  getPlatformWinloseDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/platformwinloseapi";
  },
  getDailyWinloseTournamentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosetournamentapi";
  },
  getGameResultSportsbookRefundUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultsportsbookrefundapi";
  },

  // OTP Binding URLs
  getOTP2faGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2fakeygetapi";
  },
  getOTP2faQrCodeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2faqr";
  },
  verifyOTP2faUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2favalidatedapi";
  },
  validateOTP2faUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otpsessionupdateapi";
  },
  unbindOTP2faUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/otp2fakeydisableapi";
  },
};
